import { collection, query, where, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebase';

export const getActivePopup = async () => {
  try {
    const q = query(
      collection(db, 'popups'),
      where('isActive', '==', true),
      limit(1)
    );
    
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0];
      return { id: doc.id, ...doc.data() };
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching active popup:', error);
    return null;
  }
};
